import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getOrgTermsContent } from '../../../../content/utils.js';
import { selectParentPortfoliosWithSpecial } from '../../../../modules/portfolio.js';
import { navigateToProjectReports } from '../../../links/index.jsx';

const mapStateToProps = (state) => ({
  parentPortfolios: selectParentPortfoliosWithSpecial(state),
});

ParentPortfolioFilter.propTypes = {
  parentPortfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string,
    })
  ),
  selectedParentPortfolioIds: PropTypes.arrayOf(PropTypes.number),
};

ParentPortfolioFilter.defaultProps = {
  parentPortfolios: [],
  selectedParentPortfolioIds: [],
};

function ParentPortfolioFilter({
  parentPortfolios,
  selectedParentPortfolioIds,
}) {
  const selectedCount = selectedParentPortfolioIds.length;

  const handleSelect = useCallback(
    (parentPortfolioId) => {
      return navigateToProjectReports({
        parentPortfolioIds:
          parentPortfolioId !== undefined
            ? String(parentPortfolioId).length
              ? xor(selectedParentPortfolioIds, [parentPortfolioId])
              : []
            : [],
      });
    },
    [selectedParentPortfolioIds]
  );

  const renderMenuItem = useCallback(
    (parentPortfolio) => {
      if (parentPortfolio.id === 'no_parent_portfolio') return null;

      return (
        <React.Fragment key={parentPortfolio.id}>
          <MenuItem
            active={selectedParentPortfolioIds.includes(parentPortfolio.id)}
            eventKey={parentPortfolio.id}
            onSelect={handleSelect}
          >
            {parentPortfolio.name}
          </MenuItem>
        </React.Fragment>
      );
    },
    [selectedParentPortfolioIds]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        {getOrgTermsContent('parentPortfolio')}
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="parent-portfolios-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          {parentPortfolios.map(renderMenuItem)}
          <MenuItem divider />
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(ParentPortfolioFilter);
